import React, { Component, PropTypes } from 'react'
import { translate } from 'react-i18next'
import styled from 'styled-components'
import { Metrics } from '../../Themes'
import Input from '../../components/Input'
import Button from '../../components/Button'
import { resetPassword } from '../../sources/AuthSources'
import Modal from '../../components/Modal'
import SuccessModal from '../../components/Modal/SuccessModal'
import ErrorModal from '../../components/Modal/ErrorModal'

const Container = styled.div``

const CustomButton = styled(Button)`
  margin-top: ${Metrics.margins.base};
`

const CustomText = styled.p`
  margin-top: 0;
  margin-bottom: ${Metrics.margins.base};
`

class ResetPassword extends Component {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      error: null,
      modal: false
    }
    this.handleEmailChange = this.handleEmailChange.bind(this)
    this.handleSend = this.handleSend.bind(this)
    this.handleClose = this.handleClose.bind(this)
  }

  handleEmailChange (event) {
    this.setState({ email: event.target.value })
  }

  handleSend () {
    resetPassword(this.state.email)
      .then(response => {
        this.setState({ modal: 'success' })
      })
      .catch(() => {
        this.setState({
          modal: 'error',
          error: 'An error occurred'
        })
      })
  }

  handleClose () {
    this.setState({
      success: false,
      email: null,
      error: ''
    })
    this.props.router.push('/landing')
  }

  render () {
    const { t } = this.props
    const { modal } = this.state
    let content = ''

    if (this.state.modal) {
      content =
        modal === 'success' ? (
          <SuccessModal
            visible
            header={t('Reset Password')}
            closeAction={this.handleClose}
            message={t('An email has been sent to reset your password')}
          />
        ) : (
          <ErrorModal
            visible
            header={t('Error')}
            closeAction={this.handleClose}
            message={t('There was an error when reseting your password')}
          />
        )
    } else {
      content = (
        <Modal
          visible
          header={<div className={'header'}>{t('Reset Password')}</div>}
          closeAction={this.handleClose}>
          <CustomText>
            {t(
              'Please insert your email and we will send you a link to reset your password'
            )}
          </CustomText>
          <Input
            handleChange={this.handleEmailChange}
            error={this.state.error}
            placeholder={t('Insert your email')}
          />
          <CustomButton
            className='success-button'
            label={t('Send')}
            onClick={this.handleSend}
          />
        </Modal>
      )
    }

    return <Container>{content}</Container>
  }
}

ResetPassword.propTypes = {
  router: PropTypes.object,
  t: PropTypes.func
}

export default translate([ 'common', 'landing' ], { wait: true })(ResetPassword)



// WEBPACK FOOTER //
// ./src/pages/Landing/ResetPassword.js